//-------------------------------------------------------------------------------------------------- Imports
import { Card, Col, Row } from "antd";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useCallback, useEffect, useState } from "react";
import { getChannelList } from "../../methods/Methods";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import Loading from "../../components/Loading";
import _ from "lodash";
import InfoCardComponent from "../../components/InfoCardComponent";
import { RightOutlined } from "@ant-design/icons";
import { StyleSheet } from "../../StyleSheet";
import ListItemAccordionChannel from "./components/ListItemAccordionChannel";
import { ResponseChannel } from "../../types/common";

//-------------------------------------------------------------------------------------------------- View
const ChannelList = () => {
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [listPackage, setListPackage] = useState<ResponseChannel[]>([]);
    const [channelData, setChannelData] = useState<ResponseChannel | null>(null);
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isGoBack, setIsGoBack] = useState<boolean>(false);
    const [showChannels, setShowChannels] = useState<boolean>(false);

    const getChannelListFnt = useCallback(async () => {
        setIsLoading(true);
        await getChannelList(idCliente)
            .then((response) => {
                if (response && response.data && response.data.data) {
                    if (_.isEmpty(response.data.data)) {
                        setMessage("No hay información para mostrar.");
                    } else {
                        setListPackage(response.data.data);
                    }
                }
                setIsLoading(false);
            })
            .catch(() => {
                setHasError(true);
                setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
                setIsLoading(false);
            });
    }, [idCliente]);

    const handleShowChannels = (item: ResponseChannel) => {
        setShowChannels(true);
        setIsGoBack(false);
        setChannelData(item);
    }

    const goBackBtn = () => {
        setIsGoBack(true);
    }

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) {
            getChannelListFnt();
        }
    }, [idCliente, getChannelListFnt]);

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Lista de Canales de TV"} needReturn={true} navigateTo={"/technical-support"}>
                        <div style={{ marginTop: 20 }}>
                            {
                                hasError ?
                                    <InfoCardComponent title="¡Estimado usuario!" description={message} />
                                    :
                                    !_.isEmpty(listPackage) && (!showChannels || isGoBack) ?
                                        <Row style={styles.mainContainer}>
                                            {listPackage.map((item, index) => (
                                                <Row style={styles.rowRoot}>
                                                    <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                                                        <Card key={index} style={styles.cardStyles}>
                                                            <Row style={{ cursor: 'pointer' }} onClick={() => handleShowChannels(item)}>
                                                                <Col style={styles.titleContainer}>
                                                                    <h3 style={{ color: "#757982" }}>{item.paquete.paquete}</h3>
                                                                </Col>
                                                                <Col style={styles.iconContainer}>
                                                                    <RightOutlined style={styles.iconStyles} />
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </Row>
                                        :
                                        <ListItemAccordionChannel channelData={channelData} goBackBtn={goBackBtn} />
                            }
                        </div>
                    </SubDefaultLayout >
            }
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        width: "100%",
        flexDirection: "column",
    },
    rowRoot: {
        display: 'flex',
        justifyContent: 'center',
    },
    cardStyles: {
        boxShadow: "0px 0px 8px #00000029",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 15
    },
    titleContainer: {
        flex: 1,
        display: "flex",
        height: "100%",
        alignItems: "center",
    },
    iconContainer: {
        display: "flex",
        width: 50,
        height: 50,
        alignItems: "center",
        justifyContent: "center",
    },
    iconStyles: {
        fontSize: 20,
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ChannelList;
